<template>
<div id="page-grupos">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Administrar Grupos" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <exportar-excel :data="datafiltered" :exportFields="grupos.camposexcel" name="Grupos.xlsx">
              <v-btn fab dark x-small color="success" title="Exportar a Excel" v-tippy>
                <v-icon dark>get_app</v-icon>
              </v-btn>
            </exportar-excel>
            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>

         

           
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">

              <v-client-table ref="vuetable" :data="grupos.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>
                <template slot="search">
                        <v-alert icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="getGrupo(props.row.id_grupo)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteGrupo(props.row.id_grupo)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <v-btn v-if="props.row.es_agente == 1" x-small fab dark color="green" @click.native="addPatentes(props.row.rfc, props.row.id_grupo)" title="Agregar Patentes" v-tippy>
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
        <v-dialog v-model="modal" max-width="1000px">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text" @click.native="modal = false">cancel</v-icon>&nbsp;
                    <span class="subheading">
                      <strong>{{ update ? "Actualizar" : "Nuevo" }} Grupo</strong>
                    </span>
                  </v-card>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md @keyup.enter="update ? updateGrupo() : saveGrupo()">
                    <v-row>
                    <v-col cols=12>
                      <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]"></v-text-field>
                    </v-col>
                   
                    </v-row>
                    <v-row>
                    <v-col cols=6>
                      <v-text-field label="Razón Social" v-model="model.razon_social" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols=6>
                      <v-text-field label="RFC o TAX ID" v-model="model.rfc" :rules="[
                                rules.required,
                                rules.rfclen
                              ]" maxlength="13"></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols=12>
                      <v-flex xs12>
                            <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                            <v-combo-paises :option_combos="3" :param_pais="model.pais" :param_estado="model.estado" :param_ciudad="model.ciudad" :on-select-pais="selectComboPais" :on-select-estado="selectComboEstado"
                              :on-select-ciudad="selectComboCiudad" />
                          </v-flex>
                     
                    </v-col>
                    
                    </v-row>
                    <v-row>
                    <v-col cols=6>
                      <v-text-field label="Colonia" v-model="model.colonia" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols=6>
                      <v-text-field label="Domicilio" v-model="model.domicilio" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols=6>
                      <v-text-field label="CP" v-model="model.codigo_postal" :rules="[rules.required]" maxlength="5"></v-text-field>
                    </v-col>
                    <v-col cols=6>
                      <v-text-field label="Nombre Contacto" v-model="model.nombre_contacto" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols=6>
                      <v-text-field label="Email Contacto" v-model="model.email_contacto" :rules="[rules.required, rules.email]"></v-text-field>
                    </v-col>
                    <v-col cols=6>
                      <v-text-field label="Teléfono Contacto" v-model="model.telefono_contacto" :rules="[rules.required]" maxlength="15"></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols=4>
                      <v-checkbox v-model="model.panel" :false-value="0" :true-value="1" :label="'Super Panel de Usuario'" @change="cambia(1)" ></v-checkbox>
                    </v-col>
                    <v-col cols=4>
                      <v-checkbox v-model="model.es_transportista" :false-value="0" :true-value="1" :label="'Es Transportista'" @change="cambia(2)"></v-checkbox>
                    </v-col>
                    <v-col cols=4>
                      <v-checkbox v-model="model.es_agente" :false-value="0" :true-value="1" :label="'Es Agencia Aduanal'" @change="cambia(3)"></v-checkbox>
                    </v-col>
                    </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn color="success" @click.native="update ? updateGrupo() : saveGrupo()">
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="modal2" max-width="500px">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text" @click.native="modal2 = false">cancel</v-icon>&nbsp;
                    <span class="subheading">
                      <strong>Agregar Patentes</strong>
                    </span>
                  </v-card>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form2" lazy-validation>
                    <v-container grid-list-md @keyup.enter="guardar_patentes">
                      <v-layout wrap>
                        <v-flex xs10>
                          <v-text-field label="Patente" v-model="patente_nueva" :rules="[rules.required]" v-mask="'####'"></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn fab dark x-small color="secondary" @click.native="agregarPatente" title="Agregar" v-tippy>
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete v-model="grupo_patentes" :items="grupo_patentes" chips deletable-chips multiple></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click.native="modal2 = false">
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="guardar_patentes">
                    <v-icon>done</v-icon>
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import ComboPaises from '@/components/ComboPaises/index.vue';

export default {
  components: {
    "v-combo-paises": ComboPaises,
  },
  created: function() {
    this.getPaises();
    this.getEstados();
  },
  data() {
    return {
      grupo_patentes:[],
      modal2: false,
      patente_nueva:"",
      rfc_patentes:"",
      id_grupo_selected:0,
      fab: false,
      name: "datagrid",
      columns: [
        "nombre",
        "razon_social",
        "rfc",
        "tipo",
        "nombre_contacto",
        "email_contacto",
        "telefono_contacto",
        "actions"
      ],
      
      show_loading: true,
      options: {
       // filterable: ["nombre", "razon_social", "rfc", "tipo", "nombre_contacto"],
        sortable: ["nombre", "razon_social", "rfc", "tipo" , "nombre_contacto"],
        filterable: true,
        filterByColumn: false,
        texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
        headings: {
          nombre: "Nombre",
          razon_social: "Razón Social",
          rfc: "RFC o TAX ID",
          tipo:"Tipo",
          nombre_contacto: "Nombre del contacto",
          email_contacto: "Email del contacto",
          telefono_contacto: "Teléfono de contacto",
          actions: "Operaciones"
        },
         listColumns: {
                    tipo: [{
                            id: "NORMAL",
                            text: "NORMAL"
                        },
                        {
                            id: "TRANSPORTISTA",
                            text: "TRANSPORTISTA"
                        },
                        {
                            id: "AGENCIA ADUANAL",
                            text: "AGENCIA ADUANAL"
                        },
                        {
                            id: "SUPER PANEL",
                            text: "SUPER PANEL"
                        }
                    ],
         }
      },
      show_loading: true,
      breadcrumbs: [{
          text: "Administración",
          disabled: false,
          to: "/admin"
        },
        {
          text: "Grupos",
          disabled: true,
          href: ""
        }
      ],
      title: "",
      modal: false,
      update: false,
      paises: [],
      estados_completos: [],
      estados: [],
      model: {
        id_grupo: "",
        nombre: "",
        ciudad: "",
        codigo_postal: "",
        colonia: "",
        domicilio: "",
        email_contacto: "",
        estado: "",
        nombre_contacto: "",
        pais: "",
        razon_social: "",
        rfc: "",
        telefono_contacto: "",
        panel: 0,
        es_transportista: 0,
        es_agente: 0
      },
      rules: {
        required: v => !!v || "Este campo es requerido",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Correo electrónico no valido";
        },
        rfclen: v =>
          (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
      },
      search: "",
      grupos: {
        selected: [],
        camposexcel: {
          Nombre: "nombre",
          RFC: "rfc",
          "Razón Social": "razon_social",
          "Nombre del Contacto": "nombre_contacto",
          "Email del Contacto": "email_contacto",
          "Teléfonos de Contacto": "telefono_contacto",
          "Domicilio": "domicilio",
          "Colonia": "colonia",
          "CP": "codigo_postal",
          "Ciudad": "ciudad",
          Estado: "estado_nombre",
          País: "pais_nombre"
        },
        items: [0]
      }
    };
  },
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.grupos.items;
      }

    },
  },

  methods: {

    openModal: function(type) {
      if (type === 1) {
        this.title = "Nuevo Grupo";
        this.update = false;
        this.limpiarModel();
      } else {
        this.title = "Actualizar Grupo";
        this.update = true;
      }
      this.modal = true;
    },
    limpiarModel: function() {
      for (var k in this.model) {
        this.model[k] = "";
      }
      this.model.panel = 0;
      this.model.es_transportista = 0;
      this.model.es_agente = 0;
    },
    getNombrePais: function(id_pais) {
      let pais = this.paises.filter(p => {
        return p.id_pais == id_pais;
      });

      if (pais.length === 1) return pais[0].nombre;
    },
    getNombreEstado: function(id_estado) {
      let estado = this.estados_completos.filter(e => {
        return e.id_estado == id_estado;
      });
      if (estado.length === 1) return estado[0].nombre;
    },
    getGrupos: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .get(this.$hostname + "grupos/")
        .then(response => {
          this.grupos.items = response.data;
          for (var k in this.grupos.items) {
            this.grupos.items[k].pais_nombre = this.getNombrePais(this.grupos.items[k].pais);
            this.grupos.items[k].estado_nombre = this.getNombreEstado(this.grupos.items[k].estado);
            if(this.grupos.items[k].es_transportista==1)
              this.grupos.items[k].tipo="TRANSPORTISTA";
            else if(this.grupos.items[k].es_agente==1)
              this.grupos.items[k].tipo="AGENCIA ADUANAL";
            else if(this.grupos.items[k].panel==1)
              this.grupos.items[k].tipo="SUPER PANEL";
            else 
              this.grupos.items[k].tipo="NORMAL";

          }
          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los grupos.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getPaises: function() {
      axios
        .get(this.$hostname + "paises/")
        .then(response => {
          this.paises = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los paises.",
            footer: ""
          });
        });
    },
    getEstados: function() {
      axios
        .get(this.$hostname + "estados/")
        .then(response => {
          this.estados_completos = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los estados.",
            footer: ""
          });
        }).then(() => {
          this.getGrupos();
        });
    },
    changeEstados: function() {
      this.estados = this.estados_completos.filter(estado => {
        return estado.pais == this.model.pais.id_pais;
      });
    },
    saveGrupo: function() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let data = this.model;
        //data.pais = this.model.pais.id_pais;

        axios
          .post(this.$hostname + "grupos/", data)
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El grupo se creó correctamente.",
              footer: ""
            });

            this.modal = false;
            this.getGrupos();
          })
          .catch(error => {
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: error.response.data.nombre,
              footer: ""
            });
          });
      }
    },
    getGrupo: function(id_grupo) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .get(this.$hostname + "grupos/" + id_grupo + "/")
        .then(response => {
          this.model = response.data;
          this.openModal(2);
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el grupo",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    updateGrupo: function() {
      let id_grupo = this.model.id_grupo;

      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let data = this.model;
        //data.pais = this.model.pais.id_pais;

        axios
          .put(this.$hostname + "grupos/" + id_grupo + "/", this.model)
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El grupo se actualizó correctamente.",
              footer: ""
            });

            this.getGrupos();
            this.modal = false;
          })
          .catch(error => {
            let msj = error.response.data.detail;

            if (msj === undefined) msj = error.response.data.nombre;
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: msj,
              footer: ""
            });
          });
      }
    },
    deleteGrupo: function(id_grupo) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios.delete(this.$hostname + "grupos/" + id_grupo + "/")
            .then(response => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El grupo se eliminó correctamente.",
                footer: ""
              });

              this.getGrupos();
            })
            .catch(error => {
              let mensaje;
              if (typeof error.response.data !== "undefined") {
                mensaje = error.response.data.mensaje[0];
              } else {
                mensaje = "Ocurrió un error al eliminar un grupo";
              }
              this.$root.$dialogLoader.hide();
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: ""
              });
            });
        }
      });
    },
    addPatentes: function(rfc, id_grupo) {
      this.grupo_patentes = [];
      this.rfc_patentes = "";
      this.id_grupo_selected = 0;

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .post(this.$hostname + "grupos/list_grupo_patentes/", {"id_grupo": id_grupo})
        .then(response => {
          this.grupo_patentes = response.data;
          this.rfc_patentes = rfc;
          this.id_grupo_selected = id_grupo;
          this.modal2 = true;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los datos",
            footer: ""
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    agregarPatente: function() {
      if (this.$refs.form2.validate() && this.patente_nueva.length == 4) {
        if(this.grupo_patentes.includes(this.patente_nueva)) {
          console.log("ya existe");
          return false;
        } else {
          this.grupo_patentes.push(this.patente_nueva);
          this.patente_nueva = "";
        }
      } else {
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Verifica los datos ingresados",
          footer: ""
        });
      }
    },
    guardar_patentes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        id_grupo: this.id_grupo_selected,
        rfc: this.rfc_patentes,
        patentes: this.grupo_patentes
      };
      axios
        .post(this.$hostname + "grupos/create_grupo_patentes/", data)
        .then(response => {
          this.$swal({
            type: "success",
            title: "Operación Exitosa",
            text: "Las Patentes se asignarón correctamente",
            footer: ""
          });

          this.modal2 = false;
          this.grupo_patentes = [];
          this.rfc_patentes = "";
          this.id_grupo_selected = 0;
          this.getGrupos();
        })
        .catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrío un error al guardar",
            footer: ""
          });
          this.modal2 = false;
          this.grupo_patentes = [];
          this.rfc_patentes = "";
          this.id_grupo_selected = 0;
        });
    },
    selectComboPais(id) {
      this.model.pais = id;
    },
    selectComboEstado(id) {
      this.model.estado = id;
    },
    selectComboCiudad(id) {
      this.model.ciudad = id;
    },
    cambia(i){
      if(i == 1)
       {
        this.model.es_transportista = 0;
        this.model.es_agente = 0;
       }
       if(i == 2)
       {
        this.model.panel  = 0;
        this.model.es_agente = 0;
       }
       if(i == 3)
       {
        this.model.panel  = 0;
        this.model.es_transportista = 0;
       }
    }
  }
};
</script>
